"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  area: {
    id: "window.pvpInfo.mapInfo.area",
    defaultMessage: "Area",
    description: ""
  },
  guild: {
    id: "window.pvpInfo.mapInfo.guild",
    defaultMessage: "Guild",
    description: ""
  },
  ownedBy: {
    id: "window.pvpInfo.mapInfo.ownedBy",
    defaultMessage: "Owned by {guildName} guild.",
    description: ""
  },
  ableToChallenge: {
    id: "window.pvpInfo.mapInfo.ableToChallenge",
    defaultMessage: "Able to challenge.",
    description: ""
  },
  waitingForChallengers: {
    id: "window.pvpInfo.mapInfo.waitingForChallengers",
    defaultMessage: "Waiting for challengers.",
    description: ""
  }
});

exports.default = _default;